import {
    useState,
    useMemo
} from 'react'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InfiniteMasonry from '@shared/components/InfiniteMasonry'

const DEFAULT_HEIGHT = 200

function ImageWithSkeleton({ src }) {
    const [loaded, setLoaded] = useState(false)

    return (
        <>
            {!loaded && (
                <Skeleton
                    variant='rectangular'
                    animation='wave'
                    width='100%'
                    height={DEFAULT_HEIGHT}
                />
            )}
            <img
                src={src}
                onLoad={() => setLoaded(true)}
                style={{
                    width: '100%',
                    display: loaded ? 'block' : 'none'
                }}
            />
        </>
    )
}

export default function ImageGallary({
    images,
    onImageClick
}) {
    const [selectedUser, setSelectedUser] = useState('الكل')

    const uniqueUsers = useMemo(() => 
        ['الكل', ...new Set(images.map(img => img.user).filter(Boolean))], 
    [images])

    const filteredImages = useMemo(() => {
        const withIndex = images.map((img, originalIndex) => ({ ...img, originalIndex }))
        return selectedUser === 'الكل' ? withIndex : withIndex.filter(img => img.user === selectedUser)
    }, [images, selectedUser])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }}>
            {uniqueUsers.length > 2 &&
                <FormControl
                    sx={{
                        minWidth: 200,
                        alignSelf: 'flex-start'
                    }}
                    size='small'
                >
                    <InputLabel id='user-filter-label'>المستخدم</InputLabel>
                    <Select
                        labelId='user-filter-label'
                        value={selectedUser}
                        label='المستخدم'
                        onChange={(e) => setSelectedUser(e.target.value)}
                    >
                        {uniqueUsers.map(user => (
                            <MenuItem
                                key={user}
                                value={user}
                            >{user}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
            <InfiniteMasonry
                items={filteredImages}
                renderItem={(
                    image,
                    isLast,
                    lastRef
                ) => (
                    <Box
                        key={image.id}
                        ref={isLast ? lastRef : null}
                        onClick={() => onImageClick(image.originalIndex)}
                        sx={{
                            position: 'relative',
                            maxHeight: DEFAULT_HEIGHT,
                            overflow: 'hidden',
                            cursor: 'pointer',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: 'divider'
                        }}
                    >
                        <ImageWithSkeleton src={image.url || image.image} />
                    </Box>
                )}
            />
        </Box>
    )
}